module.exports = __webpack_public_path__ + "twitter-card-600x600-eaf191d28828165c424a3b6b43efefcc.png";